import React, { useState, useEffect } from 'react';

const BecomeAffiliateMember = () => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const API_BASE_URL = 'https://backend.dlapakistan.com';

  // Load data from API on component mount
  useEffect(() => {
    fetchAffiliateData();
  }, []);

  const fetchAffiliateData = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/dla-trade/affiliate-content/current/`);
      if (response.ok) {
        const data = await response.json();
        setContent(data);
      }
    } catch (error) {
      console.error("Error loading affiliate data:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="max-w-7xl ml-0 p-10 font-sans text-[#333333]">
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-600"></div>
        </div>
      </div>
    );
  }

  if (!content) {
    return (
      <div className="max-w-7xl ml-0 p-10 font-sans text-[#333333]">
        <div className="text-center py-20">
          <p className="text-gray-500">No affiliate content available.</p>
        </div>
      </div>
    );
  }

  return (
    /* Left alignment aur padding */
    <div className="max-w-7xl ml-0 p-10 font-sans text-[#333333]">
      
      {/* Main Heading - Dynamic from API */}
      <h1 className="text-[42px] font-normal mb-6 text-[#3c4858]">
        {content.title}
      </h1>
      
      {/* Border width zada aur gray color */}
      <hr className="border-t-[3px] border-gray-100 mb-10 w-full" />

      {/* Content Area - Dynamic from API */}
      <div className="space-y-6 text-[16px] leading-relaxed text-[#333333] max-w-4xl">
        <div 
          className="prose prose-lg max-w-none"
          dangerouslySetInnerHTML={{ __html: content.description }}
        />
      </div>
    </div>
  );
};

export default BecomeAffiliateMember;